import parseUrl from 'url-parse';
import lz from 'lz-string';
import {throttle} from 'throttle-debounce';
import {StateT} from './types';

export const setDataToUrl = throttle(500, (stateString: string): void => {
    var compressedCode = lz.compressToBase64(stateString);
    replaceUrl(window.history.state, getUrlWithData(getUrl(), compressedCode));
});

export function getDataFromUrl(): StateT | null {
    const hash = parseUrl(getUrl()).hash.split('#')[1];
    if (hash === undefined || hash.length === 0) {
        return null;
    }

    const jsonString = lz.decompressFromBase64(hash);

    if (jsonString === null) {
        return null;
    }

    return JSON.parse(jsonString) as StateT;
}

export function replaceUrl(state: any, url: string) {
    window.history.replaceState(state, 'Exponential', url);
}

export function getUrlWithData(url: string, data: string) {
    const urlObj = parseUrl(url);
    urlObj.set('hash', data);
    return urlObj.toString();
}

export function getUrl() {
    return window.location.href;
}
